import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import Utils from '../util/Utils.jsx';

import {
	addLayout,
	setLayout,
	saveLayout,
	setLayoutChangedModalInfo
} from '../context/projectLayout.js';
import { useStateValue } from '../context/state.jsx';
import { openPrompt } from '../context/alert.js';

const LayoutChangedModal = (routeProps) => {
	const [{
		layoutChangedModalInfo,
		projectFilter,
		projectViewType,
		projectGroupBy,
		projectGroupByActivityCode,
		projectMapGroupBy
	}, dispatch] = useStateValue();
	const { datasetInfo } = routeProps;
	if (!layoutChangedModalInfo) {
		return null;
	}

	const close = () => {
		dispatch(setLayoutChangedModalInfo(null));
	};

	const discard = () => {
		const { changedToLayoutId } = layoutChangedModalInfo;
		dispatch(setLayout(changedToLayoutId));
		const postData = {
			dataset: datasetInfo.Id,
			layoutId: changedToLayoutId
		};
		Utils.ajax('setLayout', postData);
		close();
	};

	const saveExistingLayout = () => {
		const { changedFromLayoutId } = layoutChangedModalInfo;
		const postData = {
			dataset: datasetInfo.Id,
			layoutId: changedFromLayoutId,
			filter: JSON.stringify(projectFilter),
			viewType: projectViewType,
			groupBy: projectGroupBy,
			groupByActivityCode: projectGroupByActivityCode,
			mapGroupBy: projectMapGroupBy
		};
		Utils.ajax(
			'saveLayout',
			postData,
			dispatch,
			() => {
				dispatch(saveLayout());
			}
		);
		close();
	};

	const saveNewLayout = () => {
		dispatch(openPrompt('Save new layout (max 255 characters)', name => {
			Utils.ajax(
				'addLayout',
				{
					dataset: datasetInfo.Id,
					name
				},
				dispatch,
				result => {
					dispatch(addLayout({result, name}));
					const postData = {
						dataset: datasetInfo.Id,
						layoutId: result.Id,
						filter: JSON.stringify(projectFilter),
						viewType: projectViewType,
						groupBy: projectGroupBy,
						groupByActivityCode: projectGroupByActivityCode,
						mapGroupBy: projectMapGroupBy
					};
					Utils.ajax(
						'saveLayout',
						postData,
						dispatch,
						() => {
							dispatch(saveLayout());
						}
					);
				}
			);
		},
		'',
		'Layout name'));
		close();
	};

	return (
		<Modal
			show={layoutChangedModalInfo !== null}
			onHide={close}
			container={this}>
			<Modal.Header closeButton>
				<Modal.Title>Layout has changed</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				The layout has changed, please choose what to do with it.
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={close}>Cancel</Button>
				<Button bsStyle="danger" onClick={discard}>Discard</Button>
				<Button bsStyle="success" onClick={saveExistingLayout}>Overwrite</Button>
				<Button bsStyle="primary" onClick={saveNewLayout}>New</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default LayoutChangedModal;